module.exports = __webpack_public_path__ + "static/media/ic_type_video_active.f13ebd58.svg";